<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction
        :isShow="isShow"
        :page="this"
      >
      <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>Save
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>Cancel
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
         
          <div class="card-body">
            <div class="row">
              <MobileTextbox
                title="Role Name:"
                wrapperclass='col-12'
                labelclass='col-12'
                inputclass='col-12'
                :className="'gstGroup'"
                v-model="formData.name"
              />

            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <label class="col-form-label" :class="'col-12'">Description:</label>
                  <div class="col-12">
                    <textarea
                      class="form-control"
                      v-model="formData.description"
                      rows="3"
                      style="min-height: 100px"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
             <div class="row">
              <div class="col-12">
                <div class="row">
                  <label class="col-form-label" :class="'col-12'">Email:</label>
                  <div class="col-12">
                    <textarea
                      class="form-control"
                      v-model="formData.email"
                      rows="3"
                      style="min-height: 100px"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      
      </div>
    </section>
    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";

export default {
  title: "New Role",
  access_code: "G_MT04",
  icon: "fas fa-cog fa-fw",
  hidden: true,
  components: {},
  data() {
    return {
      componentkey: 0,
     
      isShow: null,
      gridId: "mt04",
      formData: {
          name : null,
          description : null,
          email:null
      },
      isEdit: true,
    };
  },
  created() {

  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow"]),
    cancelBtnClick(){
      this.$router.go(-1);
    },
    saveButtonClicked(){
      helper.loading();
      api.request(
        this,
        "post",
        `/system_maintenance/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData,
          }
        },
        function(r) {
          this.$router.go(-1);
        
        
        //this.$router.push({ query: Object.assign(this.$route.query, { new: r.data.form_ID }) })
        this.isEdit = true;
        this.$route.params.id = r.data.form_ID;
        },
        function(r) {
          helper.done();
        }
      );
    },
  },
  mounted() {
     this.loadForm();

  },
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>
